export const truncateText = (text, limit) => {
  if (text) {
    return text?.length < limit ? text : `${text?.substring(0, limit)}...`;
  }
  return null;
};
